
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.3399 14.2113L18.3399 12.5833C18.1299 12.2204 17.9399 11.5338 17.9399 11.1317V8.65039C17.9399 6.34558 16.5599 4.35462 14.5699 3.42289C14.0499 2.52058 13.0899 1.96154 11.9899 1.96154C10.8999 1.96154 9.91994 2.54019 9.39994 3.45231C7.44994 4.40366 6.09994 6.375 6.09994 8.65039V11.1317C6.09994 11.5338 5.90994 12.2204 5.69994 12.5735L4.68994 14.2113C4.28994 14.8685 4.19994 15.5942 4.44994 16.2612C4.68994 16.9183 5.25994 17.4283 5.99994 17.6735C7.93994 18.3208 9.97994 18.6346 12.0199 18.6346C14.0599 18.6346 16.0999 18.3208 18.0399 17.6833C18.7399 17.4577 19.2799 16.9379 19.5399 16.2612C19.7999 15.5844 19.7299 14.839 19.3399 14.2113Z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14.8301 19.6252C14.4101 20.7629 13.3001 21.5769 12.0001 21.5769C11.2101 21.5769 10.4301 21.2631 9.88005 20.704C9.56005 20.4098 9.32005 20.0175 9.18005 19.6154C9.31005 19.635 9.44005 19.6448 9.58005 19.6644C9.81005 19.6938 10.0501 19.7233 10.2901 19.7429C10.8601 19.7919 11.4401 19.8213 12.0201 19.8213C12.5901 19.8213 13.1601 19.7919 13.7201 19.7429C13.9301 19.7233 14.1401 19.7135 14.3401 19.684C14.5001 19.6644 14.6601 19.6448 14.8301 19.6252Z","fill":"currentColor"}})])
          )
        }
      }
    